import { render } from "./top-up.vue?vue&type=template&id=486d02dd"
import script from "./top-up.vue?vue&type=script&lang=js"
export * from "./top-up.vue?vue&type=script&lang=js"

import "./top-up.vue?vue&type=style&index=0&id=486d02dd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__